<template>
  <div class="risk-box">
    <el-form
      :disabled="isDialog"
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="220px"
      class="ruleForm rmgt"
    >
      <div class="risk-tips">
        注：风控规则由平台保留最终解释权，所有风控内容最终以平台设置的可调范围为准。
      </div>
      <el-form-item label="执行者年龄区间：">
        <el-input disabled :value="range.ageStart" placeholder="">
          <span disabled slot="suffix">岁</span>
        </el-input>
        <span class="line"></span>
        <el-input disabled :value="range.ageEnd" placeholder="">
          <span disabled slot="suffix">岁</span>
        </el-input>
      </el-form-item>
      <el-form-item
        label="不可重复拜访相同客户："
        prop="noCustomerDay"
        :rules="validVisitDay(1, range.dayDoctor)"
      >
        <el-input
          v-model="ruleForm.noCustomerDay"
          @blur="fommatNumber('noCustomerDay')"
          placeholder=""
          :disabled="
            +ajaxjResponse.riskBaseSzbfControl.noCustomerDayIsUpdate !== 1
          "
        >
          <span slot="suffix">天内</span>
        </el-input>
        <el-tooltip
          class="item"
          effect="dark"
          content="限制同一目标在多少天内不可重复拜访"
          placement="right-end"
        >
          <i
            class="el-icon-warning-outline"
            style="font-size: 20px;color: #409EFF"
          ></i>
        </el-tooltip>
        <span class="note-s1">可调范围：大于等于{{ range.dayDoctor }}天</span>
      </el-form-item>
      <el-form-item label="单日拜访次数：">
        <el-input
          v-model="ruleForm.numOfDaily"
          placeholder="1至30次"
          :disabled="
            +ajaxjResponse.riskBaseSzbfControl.numOfDailyIsUpdate !== 1
          "
        >
          <span slot="suffix">次</span>
        </el-input>
        <el-tooltip
          class="item"
          effect="dark"
          content="限制自然人单日对目标的拜访次数"
          placement="right-end"
        >
          <i
            class="el-icon-warning-outline"
            style="font-size: 20px;color: #409EFF"
          ></i>
        </el-tooltip>
      </el-form-item>
      <el-form-item label="反馈有效期：">
        <el-input
          type="number"
          v-model="ruleForm.effectiveDay"
          placeholder="1至7天"
          :disabled="
            +ajaxjResponse.riskBaseSzbfControl.effectiveDayIsUpdate !== 1
          "
        >
          <span slot="suffix">天</span>
        </el-input>
        <el-tooltip
          class="item"
          effect="dark"
          content="转发后在有效期内可以反馈，超过有效期不能反馈"
          placement="right-end"
        >
          <i
            class="el-icon-warning-outline"
            style="font-size: 20px;color: #409EFF"
          ></i>
        </el-tooltip>
      </el-form-item>
      <template v-if="!isDialog">
        <el-form-item>
          <span style="color:#9D9D9D">注：所有修改内容将于次日0:00生效</span>
        </el-form-item>
        <div style="display: flex;justify-content: center">
          <el-button type="primary" class="bts" @click="save">保存</el-button>
          <el-button type="primary" class="bts" @click="record">
            风控记录
          </el-button>
        </div>
      </template>
    </el-form>
    <history v-if="show"></history>
  </div>
</template>

<script>
import history from './child/history.vue';
import { makeSure } from '@/Mixin/makeSure';
import mixins from '../mixins/index';

export default {
  mixins: [makeSure, mixins],
  components: {
    history
  },
  props: {
    isDialog: {
      type: Boolean,
      default: false
    },
    obj: {
      type: Object,
      default: function() {
        return {};
      }
    },

    listobj: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {
      show: false
    };
  },
  methods: {
    fommatNumber(key) {
      this.ruleForm[key] = this.ruleForm[key].replace(/[^0-9]/g, '');
    },
    showHistory() {
      this.show = true;
    }
  }
};
</script>
<style lang="scss">
.rmgt {
  .el-input__suffix {
    right: 12px;
    color: #000;
  }
}

.risk-box {
  .ruleForm .el-form-item .el-input {
    width: 160px;
  }
}
</style>
<style scoped lang="scss">
.ruleForm {
  padding: 0;
}

.risk-tips {
  color: #9d9d9d;
  font-size: 13px;
  margin-bottom: 40px;
}

.note-s1 {
  margin-left: 30px;
  color: #9d9d9d;
  font-size: 13px;
}

.distance {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.check {
  position: absolute;
  right: 30.68%;
}

.line {
  width: 16px;
  height: 1px;
  background: #dedede;
  margin: 0 12px;
  display: inline-block;
}
</style>
